import { useMemo, useEffect } from 'react';
import { Divider, Box } from '@mui/material';
import { listCard } from '~/components/Global/Card/Card.style';
import {
  BaseButton,
  BASE_BUTTON_VARIANT,
  BASE_BUTTON_COLOR,
} from '~/components/Global/Button/BaseButton';
import { UpdateStatus } from '~/types/enum';
import { useAppDispatch } from '~/store';
import { removeTotalDownloadingItem } from '~/store/resource';
import { TFileCatalog } from '~/store/file/file.type';

type TListCardItem = {
  label: string;
  content: TFileCatalog[];
  openSingleDownload: () => void;
  labelSeries: string[];
};

const FileListCardItem = ({
  label,
  content,
  openSingleDownload,
  labelSeries,
}: TListCardItem) => {
  const dispatch = useAppDispatch();
  const overview = useMemo(() => {
    const map = {
      [UpdateStatus.old]: [] as TFileCatalog[],
      [UpdateStatus.latest]: [] as TFileCatalog[],
      ratio: 0,
      hasCanceled: false,
    };

    return map;
  }, [content]);

  // TODO: 資源更新
  // const handleAction = useCallback(
  //   (action: keyof typeof sendChannel) => {
  //     if (action === sendChannel.multipleFileUpdate) {
  //       multipleFileUpdate(overview[UpdateStatus.old]);
  //     }
  //   },
  //   [content, overview[UpdateStatus.old]],
  // );

  useEffect(() => {
    if (content.length === overview[UpdateStatus.latest].length) {
      dispatch(removeTotalDownloadingItem(labelSeries));
    }
  }, [content, overview[UpdateStatus.latest]]);

  useEffect(() => {
    if (overview.hasCanceled) {
      dispatch(removeTotalDownloadingItem(labelSeries));
    }
  }, [overview.hasCanceled]);

  return (
    <Box key={label} sx={{ position: 'relative' }}>
      <listCard.ListItem>
        <listCard.ListItemLabel>{label}</listCard.ListItemLabel>
        <listCard.Action>
          <BaseButton
            variant={BASE_BUTTON_VARIANT.GHOST}
            color={BASE_BUTTON_COLOR.SUCCESS}
            text="開啟"
            onClick={openSingleDownload}
            width="88px"
            style={{ fontSize: '18px' }}
          />

          {/* {overview[UpdateStatus.old].length > 0 && (
            <BaseButton
              variant={BASE_BUTTON_VARIANT.GHOST}
              color={BASE_BUTTON_COLOR.SECONDARY}
              text="資源更新"
              onClick={() => handleAction(sendChannel.multipleFileUpdate)}
              width="88px"
              style={{ fontSize: '18px' }}
            />
          )} */}
        </listCard.Action>
      </listCard.ListItem>
      <Divider />
    </Box>
  );
};

type TProp = {
  handleSingleDownload: (subLabel: string) => void;
  list: {
    [resource3: string]: TFileCatalog[];
  };
  label: string;
};

export const FileListCard = ({ handleSingleDownload, list, label }: TProp) => {
  return (
    <listCard.Container>
      <listCard.Head title={label} />
      <listCard.Content>
        {Object.entries(list).map(([sublabel, content]) => (
          <FileListCardItem
            key={sublabel}
            labelSeries={[label, sublabel]}
            label={sublabel}
            content={content}
            openSingleDownload={() => {
              handleSingleDownload(sublabel);
            }}
          />
        ))}
      </listCard.Content>
    </listCard.Container>
  );
};
